var module = angular.module('octopusApp.projects');

module.controller('TenantVariablesProjectsController', function ($scope, $q, $state, tenantState, tabState,  busy, octopusRepository, unsavedChanges, missingTenantVariablesLoader) {
    var vm = this;
    var tenantId = tenantState.tenantId;
    vm.projectTemplateDetails = [];
    vm.hasProjectTemplates = false;
    vm.filteredProjectId = null;
    vm.tenantProjects = [];
    vm.save = save;
    vm.refreshTenantVariables = refreshTenantVariables;
    vm.isProjectFiltered = isProjectFiltered;

    var projectsById = {};
    var environmentsById = {};
    var variables;
    var accounts = [];
    var projects = [];

    function isProjectFiltered(projectVariables){
        return projectVariables.project.Templates.length > 0 && (!vm.filteredProjectId || projectVariables.project.Id === vm.filteredProjectId);
    }

    function isAzureAccountTemplate(template) {
        return template.DisplaySettings['Octopus.ControlType'] === 'AzureAccount';
    }

    function init() {
        tenantState.missingVariables = missingTenantVariablesLoader.missingVariables(tenantId);

        tabState.isLoading.promise(tenantState.load().then(function (tenant) {
            vm.tenant = tenant;
            return $q.all([loadEnvironments(tenant), loadProjects(tenant), loadVariables(tenant)]);
        }).then(function () {
            setApplicableProjects();
            refreshTenantVariables();
        }));

        tabState.isLoading.promise(tenantState.missingVariables.loadingAsync);
    }



    function loadVariables(tenant) {
        return octopusRepository.Tenants.getVariables(tenant).then(function (tenantVariables) {
            variables = tenantVariables;
        });
    }

    function loadEnvironments(tenant) {
        var environmentIds = _.unique(_.flatten(_.values(tenant.ProjectEnvironments)));
        return octopusRepository.Environments.all({ids: environmentIds}).then(function (environments) {
            environmentsById = _.object(_.pluck(environments, "Id"), environments);
        });
    }

    function loadProjects(tenant) {
        var projectIds = Object.keys(tenant.ProjectEnvironments);
        return octopusRepository.Projects.all({ids: projectIds}).then(function (proj) {
            projects = proj;
            projectsById = _.object(_.pluck(projects, "Id"), projects);

            if (_.any(projects, function (project) {
                    return _.any(project.Templates, isAzureAccountTemplate);
                })) {
                return octopusRepository.Accounts.all().then(function (acc) {
                    accounts = acc;
                });
            }
        });
    }

    function setApplicableProjects() {
        vm.tenantProjects = projects.filter(function (project) {
            return Object.keys(variables.ProjectVariables).indexOf(project.Id) !== -1;
        });
    }

    function cloneTemplatesWithValues(project, envId, variables) {
        return project.Templates.map(function (template) {
            var templateCopy = _.clone(template);
            if (isAzureAccountTemplate(template)) {
                templateCopy.selectOptions = {
                    'AzureAccount': accounts.filter(function (acc) {
                        return !acc.EnvironmentIds || acc.EnvironmentIds.length === 0 || acc.EnvironmentIds.indexOf(envId) !== -1;
                    })
                };
            }
            templateCopy.DisplaySettings = _.clone(template.DisplaySettings);
            templateCopy.value = variables[template.Id] || template.DefaultValue;
            templateCopy.isMissingValue = tenantState.missingVariables.isMissing(template.Id, envId);
            return templateCopy;
        });
    }

    function refreshTenantVariables() {
        vm.hasProjectTemplates = false;
        vm.projectTemplateDetails = _.map(variables.ProjectVariables, function(projectVariable) {
            var project = projectsById[projectVariable.ProjectId];
            var templates = _.map(projectVariable.Variables, function (variables, envId) {
                return {
                    environmentId: envId,
                    environment: environmentsById[envId],
                    templates: cloneTemplatesWithValues(project, envId, variables)
                };
            });

            vm.hasProjectTemplates = vm.hasProjectTemplates || projectVariable.Templates.length > 0;
            return {
                project: project,
                environmentIds: Object.keys(projectVariable.Variables),
                templatesByEnvironment: templates
            };
        });
    }

    function save() {
        variables.ProjectVariables = modelToResource();
        tenantState.isSaving.promise(octopusRepository.Tenants.setVariables(vm.tenant, variables).then(function (a) {
            unsavedChanges.saved();
            init();

        }));

        function modelToResource() {
            return vm.projectTemplateDetails.reduce(function(idx, val) {
                idx[val.project.Id] = {
                    ProjectId: val.project.Id,
                    ProjectName: val.project.Name,
                    Templates: val.project.Templates,
                    Variables: mapEnvironmentsToResource(val.templatesByEnvironment)
                };
                return idx;
            }, {});

            function mapEnvironmentsToResource(templatesByEnvironment){
                return templatesByEnvironment.reduce(function(idx, val){
                    idx[val.environmentId] =  mapTemplatesToResource(val.templates);
                    return idx;
                }, {});
            }

            function mapTemplatesToResource(templates){
                return templates.reduce(function(a, b) { a[b.Id] = b.value; return a;}, {});
            }
        }
    }

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/variables/tenant_variables_projects.js
// module id = 639
// module chunks = 1